/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!********************************************!*\
  !*** ./src/scripts/sections/navigation.js ***!
  \********************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var navigation = function navigation(template) {
  return {
    mainContainer: null,
    mainContainerWidth: null,
    showMegaMenu: false,
    selectedHandle: null,
    selectedItem: null,
    showMobileMenu: false,
    selectedMobileHandle: null,
    showSubMenu: false,
    showThirdLevelSubMenu: false,
    body: null,
    selectedThirdLevelMobileHandle: null,
    menuInner: null,
    headerHeight: null,
    announcementBar: null,
    announcementBarHeight: 0,
    headerGroup: null,
    scrollUp: "",
    scrollDown: "",
    lastScroll: 0,
    topPosition: 0,
    megaMenuOverlay: null,
    mobileMenuWrapper: null,
    mobileOverlay: null,
    mobileMenuBottomPanel: null,
    navigationItems: null,
    stickyFilter: null,
    searchResultsContainer: null,
    isSecondLevelShown: false,
    secondLevelNavigation: null,
    init: function init() {
      var _this = this;
      this.mainContainer = document.querySelector("main");

      // this.stickyFilter = document.querySelector(".sticky_filter")
      this.scrollUp = "scroll-up";
      this.scrollDown = "scroll-down";
      this.headerContent = document.getElementById("HeaderContent");
      this.announcementBar = document.querySelector(".announcement-bar");
      this.headerGroup = document.querySelector(".header-group");
      this.secondLevelNavigation = this.headerGroup.querySelector(".second-level-navigation");
      this.isSecondLevelShown = this.headerGroup.getAttribute("data-show-second-level");
      this.megaMenuOverlay = document.querySelector('.megamenu-overlay');
      this.mobileMenuWrapper = document.querySelectorAll('.mobile-menu__wrapper');
      this.mobileOverlay = document.querySelector('.mobile-overlay');
      this.mobileMenuBottomPanel = document.querySelector('.mobile-menu__bottom-panel');
      this.searchResultsContainer = document.querySelector('.search-suggestions');
      this.navigationItems = document.querySelectorAll(".navigation-item");
      this.calculateAnnouncementBarHeight();
      this.body = document.querySelector("html body");
      this.menuInner = document.querySelectorAll(".menu-inner");
      setTimeout(function () {
        document.body.classList.add('is-header-sticky');
        if (!_this.announcementBarHeight) {
          _this.mainContainer.style.paddingTop = _this.headerGroup.offsetHeight + 'px';
        } else {
          _this.mainContainer.style.paddingTop = _this.headerGroup.offsetHeight + _this.announcementBarHeight + 'px';
        }
      }, 0);
      this.setTopPosition();
      this.calculateHeaderWidth();
      this.setMegaMenuTopPosition();
      window.addEventListener("resize", function () {
        _this.headerHeight = _this.headerGroup.offsetHeight;
        _this.calculateAnnouncementBarHeight();
        _this.setTopPosition();
        _this.setMegaMenuTopPosition();
        _this.calculateHeaderWidth();
        _this.setMainSectionPaddingTopConditionally(_this.headerHeight);
      });
      window.addEventListener("scroll", function () {
        var currentScroll = window.pageYOffset;
        if (currentScroll > 0 && currentScroll > _this.lastScroll && !_this.body.classList.contains(_this.scrollDown)) {
          _this.body.classList.remove(_this.scrollUp);
          _this.body.classList.add(_this.scrollDown);
          if (_this.announcementBar) {
            _this.headerContent.style.transform = "translateY(-".concat(_this.announcementBarHeight, "px)");
            if (_this.mobileMenuWrapper) {
              _this.mobileMenuWrapper.forEach(function (wrapper) {
                wrapper.style.height = "100dvh";
                wrapper.style.transform = "translateY(".concat(_this.announcementBarHeight, "px)");
              });
            }
          }
        }
        if (currentScroll < _this.lastScroll && _this.body.classList.contains(_this.scrollDown)) {
          _this.body.classList.remove(_this.scrollDown);
          _this.body.classList.add(_this.scrollUp);
          if (_this.announcementBar) {
            _this.headerContent.style.transform = "translateY(0)";
            if (_this.mobileMenuWrapper) {
              _this.mobileMenuWrapper.forEach(function (wrapper) {
                wrapper.style.height = "100dvh";
                wrapper.style.transform = "translateY(0)";
              });
            }
          }
        }
        _this.lastScroll = currentScroll;
        _this.calculateHeaderWidth();
        _this.setTopPosition();
        _this.setMegaMenuTopPosition();
        _this.setMainSectionPaddingTopConditionally();
      });
    },
    calculateAnnouncementBarHeight: function calculateAnnouncementBarHeight() {
      if (this.announcementBar) {
        this.announcementBarHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
      }
    },
    setTopPosition: function setTopPosition() {
      if (this.announcementBar) {
        if (this.announcementBar.style.transform === "translateY(-".concat(this.announcementBarHeight, "px)")) {
          this.topPosition = Math.ceil(this.headerGroup.offsetHeight);
        } else {
          this.topPosition = Math.ceil(this.headerGroup.offsetHeight + this.announcementBarHeight);
        }
      } else {
        this.topPosition = Math.ceil(this.headerGroup.offsetHeight);
      }
    },
    calculateHeaderWidth: function calculateHeaderWidth() {
      var _this2 = this;
      this.mainContainerWidth = this.mainContainer;
      if (this.announcementBar) {
        this.announcementBar.style.width = this.mainContainerWidth.offsetWidth + "px";
      }
      this.headerGroup.style.width = this.mainContainerWidth.offsetWidth + "px";
      this.megaMenuOverlay.style.width = this.mainContainerWidth.offsetWidth + "px";
      this.menuInner.forEach(function (element) {
        element.style.width = _this2.mainContainerWidth.offsetWidth + "px";
      });
    },
    preventBodyScroll: function preventBodyScroll() {
      document.querySelector("body").style.overflow = "scroll";
      document.querySelector("html").style.overflow = "hidden";
      document.querySelector("html").style.maxHeight = "100vh";
    },
    allowBodyScroll: function allowBodyScroll() {
      document.querySelector("body").style.overflow = "";
      document.querySelector("html").style.overflow = "";
      document.querySelector("html").style.maxHeight = "";
    },
    openMegaMenu: function openMegaMenu(event, handle) {
      this.preventBodyScroll();
      if (window.innerWidth >= 991) {
        if (handle) {
          var navigationItems = document.querySelectorAll('.main-navigation__item');
          if (navigationItems) {
            navigationItems.forEach(function (item) {
              item.classList.remove('mega-menu-open');
            });
          }
          this.selectedItem = event.target;
          var selectedItem = this.selectedItem.querySelector('.main-navigation__item');
          if (selectedItem) {
            selectedItem.classList.add('mega-menu-open');
          }
          this.selectedHandle = event.target.querySelector("[data-submenu]").getAttribute("data-handle");
          this.showMegaMenu = true;
        } else {
          this.showMegaMenu = false;
          this.selectedHandle = null;
          this.allowBodyScroll();
        }
        this.selectActiveNavigationItem(event);
      }
    },
    closeMegaMenu: function closeMegaMenu(event) {
      if (window.innerWidth >= 991) {
        var navigationItems = document.querySelectorAll('.main-navigation__item');
        if (navigationItems) {
          navigationItems.forEach(function (item) {
            item.classList.remove('mega-menu-open');
          });
        }
        this.showMegaMenu = false;
        this.selectedHandle = null;
        this.allowBodyScroll();
        this.selectActiveNavigationItem(event);
      }
    },
    openSimpleMenu: function openSimpleMenu(event, handle) {
      this.preventBodyScroll();
      this.selectedHandle = event.target.querySelector("[data-simple-menu]").getAttribute("data-simple-menu-handle");
      this.showMegaMenu = true;
      var navigationItems = document.querySelectorAll('.main-navigation__item');
      if (navigationItems) {
        navigationItems.forEach(function (item) {
          item.classList.remove('mega-menu-open');
        });
      }
      this.selectedItem = event.target;
      var selectedItem = this.selectedItem.querySelector('.main-navigation__item');
      if (selectedItem) {
        selectedItem.classList.add('mega-menu-open');
      }
      this.selectActiveNavigationItem(event);
    },
    openMobileMenu: function openMobileMenu() {
      this.showMobileMenu = true;
      document.querySelector("body").classList.add("overflow-hidden");
      if (this.body.style.overflow === "visible") {
        this.body.style.overflow = "hidden";
      }
    },
    closeMobileMenu: function closeMobileMenu() {
      this.showMobileMenu = false;
      this.closeSubmenu();
      document.querySelector("body").classList.remove("overflow-hidden");
      this.body.style.overflow = "visible";
    },
    openSubmenu: function openSubmenu(event, handle) {
      this.showSubMenu = true;
      this.selectedMobileHandle = event.target.getAttribute("data-handle") || event.currentTarget.closest('a').getAttribute("data-handle");
    },
    openThirdSubmenu: function openThirdSubmenu(event, handle) {
      this.showThirdLevelSubMenu = true;
      this.selectedThirdLevelMobileHandle = event.target.getAttribute("data-handle") || event.currentTarget.closest('a').getAttribute("data-handle");
    },
    closeSubmenu: function closeSubmenu() {
      this.showSubMenu = false;
    },
    closeThirdSubmenu: function closeThirdSubmenu() {
      this.showThirdLevelSubMenu = false;
    },
    setMegaMenuTopPosition: function setMegaMenuTopPosition() {
      var _this3 = this;
      // if (this.stickyFilter){
      //   this.stickyFilter.style.top = this.topPosition + 'px'
      // }

      if (this.isSecondLevelShown) {
        this.menuInner.forEach(function (element) {
          element.style.top = _this3.headerGroup.offsetHeight - _this3.secondLevelNavigation.offsetHeight + _this3.announcementBarHeight + 'px';
        });
      } else {
        this.menuInner.forEach(function (element) {
          element.style.top = _this3.headerGroup.offsetHeight + _this3.announcementBarHeight + 'px';
        });
      }
      this.searchResultsContainer.style.top = this.headerGroup.offsetHeight + 'px';
    },
    setMainSectionPaddingTopConditionally: function setMainSectionPaddingTopConditionally(height) {
      if (this.body.classList.contains('scroll-down')) {
        this.mainContainer.style.paddingTop = height + 'px';
      } else {
        this.mainContainer.style.paddingTop = height + this.announcementBarHeight + 'px';
      }
    },
    selectActiveNavigationItem: function selectActiveNavigationItem(event) {
      var selectedItemHeading = event.currentTarget.getAttribute("data-item-heading");
      this.navigationItems.forEach(function (item) {
        item.style.opacity = "100%";
        var itemHeading = item.getAttribute("data-item-heading");
      });
    }
  };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (navigation);
document.addEventListener("alpine:init", function () {
  Alpine.data("navigation", navigation);
});
/******/ })()
;